import TerritoryModule from "@/pages/super-admin/components/TerritoryModule";

export default function SuperAdminCommunesPage() {
  return <TerritoryModule level="commune" />;
}